const uploadImageToOracle = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    // Get token from localStorage
    const token = localStorage.getItem('token');
    const STD_API_URL = process.env.STD_API_URL

    console.log('📤 Uploading image to Oracle:', file.name);

    const response = await fetch(`${STD_API_URL}students/assessments/uploadGeneratedImage`, {
      method: 'POST',
      headers: {
        // Backend's verifyToken middleware feeds the whole header
        // into jwt.verify() — send the raw token without "Bearer ".
        'Authorization': token,
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Upload failed with status ${response.status}`);
    }

    const data = await response.json();
    
    // ✅ Extract just the filename from the objectKey (remove "images/" prefix)
    const objectKey = data.data.objectKey; // e.g., "images/image_123.jpg"
    const filename = objectKey.replace(/^images\//, ''); // e.g., "image_123.jpg"
    
    console.log('✅ Image uploaded successfully:', {
      fileName: file.name,
      objectKey: filename, // Store without folder
      fullPath: objectKey, // Original full path
      parUrl: data.data.parUrl
    });

    return {
      success: true,
      objectKey: filename, // ✅ Return without "images/" prefix
      parUrl: data.data.parUrl
    };
  } catch (error) {
    console.error('❌ Error uploading image:', error);
    return {
      success: false,
      error: error.message
    };
  }
};
  
  export { uploadImageToOracle };